import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import "./index.css";

export default class PaperPublishedSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }
  handleClose = () => {
    this.setState({ isModalOpen: false });
  };
  handleOpen = () => {
    this.setState({ isModalOpen: true });
  };
  handleChange = (name, event) => {
    this.setState({ [name]: event.target.value });
  };

  render() {
    return (
      <div id="paperpublishedsection">
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>Research</h1>
          <ol>
            <li className="paper-link-item">
              <a
                className="paper-link"
                target="_blank"
                href="https://arxiv.org/abs/1910.13801"
              >
           
                <i>
  
                  Indian EmoSpeech Command Dataset: A dataset for emotion based
                  speech recognition in the wild
                </i>
              </a>
              <ul>
                <li type="square">
                  <h4 style={{ fontWeight: "300" }}>
                    Keyword Spotting Top-1 accuracy :{" "}
                    <span style={{ fontWeight: "bold" }}> 92%</span>
                  </h4>
                </li>
                <li type="square">
                  <h4 style={{ fontWeight: "300" }}>
                    Emotion Classification Top-1 accuracy :{" "}
                    <span style={{ fontWeight: "bold" }}> 90%</span>
                  </h4>
                </li>
              </ul>
              <p style={{ color: "gray" }}>
                If you find this useful in your research, consider <span style={{cursor:'pointer',color:'#FF0066'}} onClick={this.handleOpen}> citing</span> 
                <br />
              </p>
              <Dialog
                open={this.state.isModalOpen}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">Cite</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {`@misc{banga2019indian,
    title={Indian EmoSpeech Command Dataset: A dataset for emotion based speech recognition in the wild},
    author={Subham Banga and Ujjwal Upadhyay and Piyush Agarwal and Aniket Sharma and Prerana Mukherjee},
    year={2019},
    eprint={1910.13801},
    archivePrefix={arXiv},
    primaryClass={eess.AS},}`}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" onClick={this.handleClose}>
                    Done
                  </Button>
                </DialogActions>
              </Dialog>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}
